<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <v-card class="coming-soon-modal">
      <v-card-title>
        <h2 class="font card-title">¡Importante!</h2>
      </v-card-title>
      <v-card-text v-if="this.step === 1" class="font card-text">
        Vas a eliminar {{this.organization.name}} y toda su información.<br>¿Deseas continuar?
      </v-card-text>
      <v-card-text v-else class="font card-text">
        Eliminar {{this.organization.name}} y toda su información.
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="onCancel()">Cancelar</v-btn>
        <v-btn v-if="this.step === 1" color="primary" text @click="onContinue()">Continuar</v-btn>
        <v-btn v-else color="primary" text @click="onContinue()">Eliminar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import { DISCONNECT_ORGANIZATION_FROM_USER_MUTATION } from '../../constants/graphql';
  export default {
    data () {
      return {
        step: 1
      };
    },
    props: {
      dialog: {
        type: Boolean,
        default: false
      },
      organization: {
        type: Object,
        default: {}
      }
    },
    computed: {
    },
    watch: {
      dialog (val) {
        this.$emit('update:dialog', !!val);
      }
    },
    methods: {
      onCancel () {
        this.$emit('update:dialog', false);
      },
      onContinue () {
        if (this.step === 2) {
          this.organization.User.forEach((user) => {
            this.$apollo.mutate({
              mutation: DISCONNECT_ORGANIZATION_FROM_USER_MUTATION,
              variables: {
                userId: user.id,
                orgId: this.organization.id
              }
            }).then(() => {
              this.$emit('remove-org-event');
            }).catch(() => {
            });
            this.$emit('update:dialog', false);
          });
        } else {
          this.step = 2;
        }
      }
    }
  };
</script>


// WEBPACK FOOTER //
// RemoveOrganizationModal.vue?1778f410